<template>
  <BaseDataList ref="dataList" :items="accProductReactions" :service="fetchAccProductReactions">
    <template #header>
      <AccProductReactionListHeader />
    </template>

    <template #default="{ item }">
      <AccProductReactionListItem
        :acc-product-reaction="item"
        @acc-product-reaction-deleted="refreshList"
      />
    </template>
  </BaseDataList>
</template>

<script>
import { contactAccProductReactionsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import AccProductReactionListHeader from './AccProductReactionListHeader.vue';
import AccProductReactionListItem from './AccProductReactionListItem.vue';

export default {
  components: {
    AccProductReactionListHeader,
    AccProductReactionListItem,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      accProductReactions: [],
    };
  },
  methods: {
    refreshList() {
      this.$refs.dataList.resetList();
    },
    async fetchAccProductReactions() {
      try {
        const response = await contactAccProductReactionsClient.list(this.contactId, {
          include: 'accProduct,accProductReactionType',
        });

        this.accProductReactions = response.data.map(mapKeysToCamelCase);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
